import { getFontSize } from '../../helpers/fontSize'
import { formatByTheme } from '../../helpers/theme'

const attrs = [
  'backgroundColor',
  'borderColor',
  'borderBottomColor',
  'borderTopColor',
  'borderLeftColor',
  'borderRightColor',
  'color',
]

export const getStyle = (style, theme, typeFontSize) => {
  let result = { ...style }

  attrs.forEach((attr) => {
    if (style[attr]) {
      result = {
        ...result,
        [attr]:
          style[attr] === 'none'
            ? style[attr]
            : formatByTheme(style[attr], theme),
      }
    }
  })

  if (style.fontSize) {
    result = {
      ...result,
      fontSize: getFontSize(style.fontSize, typeFontSize),
    }
  }

  return result
}
